module.exports = __webpack_public_path__ + "img/image176.3d97f9ab.png";